<template>
<div class="chapter">
<div class="inner_page">
<svg height="100%" version="1.1" viewbox="0 0 600 800" width="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<rect fill="#FFFFFF" height="100%" width="600" x="0" y="0"></rect>
<image height="800" transform="translate(0 0)" width="600" xlink:href="../Images/DublinNoir_frontcover.jpg"></image>
</svg>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Brue_ISBN9781936070282_epub_cov0_r1.vue?326b0720